// pages/.../WarehouseFormContainer.tsx
import React from 'react';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { WarehouseDataForm } from '../../../app/models/Warehouse';
import WarehouseForm from './forms/WarehouseForm';

type SelectOpt = { id: number | string; name: string };

interface Props {
  fetching?: boolean;
  action: () => void;
  cancel: () => void;
  warehouse: WarehouseDataForm;
  setWarehouse: (data: WarehouseDataForm) => void;
  centers: SelectOpt[];
  setCenters: (opts: SelectOpt[]) => void;
  warehouseTypes: SelectOpt[];
  setWarehouseTypes: (opts: SelectOpt[]) => void;
  errorFields?: any;
}

const WarehouseFormContainer = ({
  fetching,
  action,
  cancel,
  warehouse,
  setWarehouse,
  centers,
  setCenters,
  warehouseTypes,
  setWarehouseTypes,
  errorFields = null
}: Props) => {
  return (
    <>
      <div className="row">
        <div className="col-12">
          <WarehouseForm
            warehouseDataForm={warehouse}
            setWarehouseDataForm={setWarehouse}
            centers={centers}
            warehouseTypes={warehouseTypes}
            errorFields={errorFields}
          />
        </div>
      </div>
      <hr />
      <div className="row justify-content-end">
        <div className="col-auto">
          <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
        </div>
        <div className="col-auto">
          <ButtonSaveForm callbackSave={action} locked={fetching} />
        </div>
      </div>
    </>
  );
};

export default WarehouseFormContainer;
